// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1aOPd","buttons":"RemoveExpirationActionButtons_buttons__3sYH5"};